export default class Router {
  basePath: string;
  showRouterName: string;
  createRouteName: string;
  updateRouteName: string;
  listRouteName: string;

  constructor(
    basePath: string,
    showRouterName: string,
    createRouteName: string,
    updateRouteName: string,
    listRouteName: string
  ) {
    this.basePath = basePath;
    this.showRouterName = showRouterName;
    this.createRouteName = createRouteName;
    this.updateRouteName = updateRouteName;
    this.listRouteName = listRouteName;
  }

  public show(id: number): Record<string, unknown> {
    return {
      name: this.showRouterName,
      params: { id }
    };
  }

  public create(): Record<string, unknown> {
    return {
      name: this.createRouteName
    };
  }

  public update(id: number): Record<string, unknown> {
    return {
      name: this.updateRouteName,
      params: { id }
    };
  }

  public list(): Record<string, unknown> {
    return {
      name: this.listRouteName
    };
  }
}
